const BASE_URL = "https://nriwa.com/app/"; 
const IMAGE_URL = "https://nriwa.com/app/"; 

export default BASE_URL;